<li class="nav-item dropdown pl-4 pr-2 d-sm-down-none user-bar-nav" placement="bottom right">
  <a class="nav-link" data-toggle="dropdown" role="button" style="cursor: default;">
    <i class="fa fa-user-circle">&nbsp;</i>
    {{userDisplayName$ | async}}
  </a>
</li>
